<section id="topValue">
    <div *ngIf="currentUrl !== 'Fees'" class="container text-center" >
        <p class="text-center mb-3 col-md-13" style="font-size: 16px;" >
           <!-- <b> 
            Smile Orchard, Beckspool Road, Frenchay, Bristol, BS16 1NU. Telephone BS16 1NU. Naik Dental Services Limited trading as Smile Orchard is a credit broker not a lender. Registered in England & Wales 08835795. Registered Address: Smile Orchard, Beckspool Road, Frenchay, Bristol, England, BS16 1NU
            </b> -->
            <b>
                NAIK DENTAL SERVICES LIMITED trading as Smile Orchard is an Appointed Representative of Chrysalis Finance Limited, which is authorised and regulated by the Financial Conduct Authority. NAIK DENTAL SERVICES LIMITED is a credit broker, not a lender. The provider of a payment scheme which is not offered through or by Chrysalis Finance Limited may not be so authorised and regulated. 
            </b>
        </p>
    </div>
    <div *ngIf="bannerDetails && bannerDetails.length>0">
        <div *ngFor="let item of bannerDetails">
            <marquee scrolldelay="10" class="mb-3 primaryBackgroundColor">
                <div [innerHTML]="item.BannerText" class="py-3" *ngIf="item.AllowBannerFlag===0"></div>
            </marquee>
        </div>
    </div>
    <div *ngIf="isNoForm" class="footer-item" style="background-image: url({{videoCdnUrl}}images/contact-us.jpg)">
        <div class="overlay"></div>
        <div class="container">
            <div class="row slider-text align-items-center justify-content-center" data-scrollax-parent="true">
                <div class="col-md-6 col-sm-12 ftco-animate mt-5" data-scrollax=" properties: { translateY: '70%' }">
                    <h1 class="mb-4 text-center" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">Email
                        Us</h1>
                    <p class="text-center">Send us an email using the contact form and one of our friendly team will be
                        in touch.</p>
                    <p class="text-center">Field with (*) are required. </p>
                    <p class="text-center">Please contact us via this website or email
                        without disclosing confidential information.</p>
                    <div class="row block-9">
                        <div class="col-md-12">
                            <form [formGroup]="formVar" id="ContactForm">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="*Your Name"
                                        formControlName="name" required
                                        [ngClass]="{'red-border-class': submitted && formVar.controls['name'].errors}" 
                                        [(ngModel)]="UserName" [readonly]="isReadOnly" >
                                        <span style="font-size: 7pt;" class="text-warning error-msg-txt mb-0 pb-0"
                                        *ngIf="formVar.controls['name'].errors?.pattern">No Special characters allowed</span>
                                    </div>
                                <div class="form-group">
                                    <input type="email" class="form-control" placeholder="*Your Email"
                                        formControlName="email" required  [(ngModel)]="Email" [readonly]="isReadOnly"
                                        [ngClass]="{'red-border-class': submitted && formVar.controls['email'].errors}">
                                    <span style="font-size: 7pt;" class="text-warning error-msg-txt mb-0 pb-0"
                                        *ngIf="formVar.controls['email'].errors?.pattern">Email
                                        required format is john@example.com.</span>
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Phone" id="phoneNumber"
                                        formControlName="phoneNumber"  [(ngModel)]="PhoneNumber" [readonly]="isReadOnly" >
                                        <span style="font-size: 10pt;" class="text-warning error-msg-txt mb-0 pb-0"
                                        *ngIf="formVar.controls['phoneNumber'].errors?.pattern">The
                                        Phone Number must
                                        contain digits only.</span>
                                </div>
                                <div class="form-group" *ngIf="!isLoggedIn">
                                    <select class="form-control" id="foundUs" formControlName="foundUs" required
                                        [ngClass]="{'red-border-class': submitted && formVar.controls['foundUs'].errors}">
                                        <option value="" selected disabled>*How did you find us?</option>
                                        <option value="Google Search">Google Search</option>
                                        <option value="Recommendation">Recommendation</option>
                                        <option value="Walking Past">Walking Past</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-md-6 col-sm-12">
                                        <div class="form-group pr-1 preferredDateCol">
                                            <select class="form-control" id="preferredDay"
                                                formControlName="preferredDay">
                                                <option value="" selected disabled>Preferred Day</option>
                                                <option value="Monday">Monday</option>
                                                <option value="Tuesday">Tuesday</option>
                                                <option value="Wednesday">Wednesday</option>
                                                <option value="Thursday">Thursday</option>
                                                <option value="Friday">Friday</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12">
                                        <div class="form-group pl-1 preferredDateCol">
                                            <select class="form-control" id="preferredDate"
                                                formControlName="preferredDate">
                                                <option value="" selected disabled>Preferred Time</option>
                                                <option value="Morning">Morning</option>
                                                <option value="Afternoon">Afternoon</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="PlanID">
                                    <select class="form-control" id="PlanIDValue" formControlName="PlanIDValue"
                                        [(ngModel)]="PlanID">
                                        <option value="" selected disabled>*AGBT Plans</option>
                                        <option [value]="item.PlanID" *ngFor="let item of AGBTPlans">{{item.PlanName}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <textarea name="" id="Message" cols="30" rows="3" class="form-control"
                                        placeholder="Message *" formControlName="Message" required [ngClass]="{'red-border-class': submitted && formVar.controls['Message'].errors}"></textarea>
                                </div>
                                <div class="custom-control custom-checkbox"
                                    [ngClass]="{'red-border-class': submitted && formVar.controls['consent1'].errors}">
                                    <input type="checkbox" class="custom-control-input" id="privacyConsent"
                                        formControlName="consent1" required>
                                    <label class="custom-control-label" for="privacyConsent">* I consent to my personal
                                        data
                                        being collected and stored as per the <a routerLink="/Privacy Policy"
                                            target="_blank">Privacy
                                            Policy</a>. </label>
                                </div>
                                <div class="custom-control custom-checkbox mb-3">
                                    <input type="checkbox" class="custom-control-input" id="marketingConsent">
                                    <label class="custom-control-label" for="marketingConsent">I consent to my personal
                                        data
                                        being collected and stored for the purpose of marketing communications.</label>
                                </div>
                                <div class="form-group">
                                    <input type="submit" (click)="sendMessage()" value="Send Message"
                                        class="btn btn-primary py-2 px-5">
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="secondaryBackgroundColor pt-5 pb-5" *ngIf="!noFooter">
        <div class="container p-5 mb-5 primaryBackgroundColor">
            <div class="row no-gutters">
                <div class="col-md-4 col-sm-12 text-center" data-aos-duration="5000" data-aos="fade-left">
                    <h2>Opening Hours</h2>
                    <ul role="list" class="opening-hours p-0 pt-3 pl-5 pr-5 main-container">
                        <li><span>Monday</span> <span>9.00-17.00</span></li>
                        <li><span>Tuesday</span> <span>9.00-17.00</span></li>
                        <li><span>Wednesday</span> <span>9.00-17.00</span></li>
                        <li><span>Thursday</span> <span>9.00-17.00</span></li>
                        <li><span>Friday</span> <span>9.00-17.00</span></li>
                        <li><span>Saturday</span> <span>&nbsp;9.00-17.00*</span></li>
                        <p>(* on prior appointments only)</p>
                    </ul>
                </div>
                <div class="col-md-4 col-sm-12 text-center" data-aos-duration="5000" data-aos="fade-down">
                    <h2>Contact Details</h2>
                    <p class="text-center">Smile Orchard</p>
                    <p class="text-center">Beckspool Road</p>
                    <p class="text-center">Frenchay, Avon</p>
                    <p class="text-center">Bristol, BS16 1NU</p>
                    <p><a href="mailto:info@smileorchard.co.uk" class="text-center mb-0">info@smileorchard.co.uk</a></p>
                    <a href="tel:01179 567603" class="text-center">01179 567603</a>
                    <div class="row no-gutters justify-content-center mt-2 mb-2">
                        <a href="https://www.instagram.com/smileorchardfrenchay/" aria-label="Instagram" target="_blank" rel="noopener">
                            <img loading="lazy" src="{{videoCdnUrl}}images/instagram-icon.png"  alt="insta">
                        </a>
                        <a href="https://www.facebook.com/smileorchardfrenchay" aria-label="facebook" target="_blank" rel="noopener">
                            <img loading="lazy" src="{{videoCdnUrl}}images/facebook-icon.png"  alt="facebook">
                        </a>
                        <a href="https://www.youtube.com/channel/UCGmsdCei759I6YSgmOurQyg" aria-label="youtube" target="_blank" rel="noopener">
                            <img loading="lazy" src="{{videoCdnUrl}}images/youtube-icon.png"  alt="youtube">
                        </a>
                        <a href="https://www.linkedin.com/company/smile-orchard"  aria-label="linkedin" target="_blank" class="ml-2" rel="noopener">
                            <img loading="lazy" src="{{videoCdnUrl}}images/linkedin.png" alt="linkedin">
                        </a>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12 text-center" data-aos-duration="5000" data-aos="fade-right">
                    <h2>How to Find Us</h2>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d717.4043313019132!2d-2.517708725425366!3d51.499295520662926!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd9a9d8437659c573!2sFrenchay+Dental+Practice+and+Implant+Centre!5e0!3m2!1sen!2sus!4v1509024911154"
                        width="300" height="200" frameborder="0" style="border:0" allowfullscreen
                        title="Find us"></iframe>
                </div>
               
            </div>
        </div>
      
        <div class="w-100" style="font-size: 12px;">
            <p class="text-center mb-1">Copyright &copy;
                <script>document.write(new Date().getFullYear());</script> All rights reserved by <a
                    href="https://futuredent.co.uk/" target="_blank" rel="noopener">Naik Dental Service Limit.</a>
            </p>
            <p class="text-center">Version {{Version}}</p>
        </div>
    </div>
</section>


<div class="modal fade" id="ModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="text-center p-3 pt-4" id="messageText">
                    <p class="text-success" *ngIf="isSuccess">Thank you for contacting us.  We will be in touch with you shortly.</p>
                    <p class="text-danger" *ngIf="isError">Oops! Something went wrong. Please try again.</p>
                    <p class="text-danger" *ngIf="isFieldValidation">Please fill in the (*)required fields highlighted in red.</p>
                </div>
                <div class="w-100 text-center">
                    <button type="button" class="btn btn-outline-primary btn-border-radius" data-dismiss="modal"
                        aria-label="Close">OK</button>
                </div>
            </div>
        </div>
    </div>
</div>